import React from 'react';

import MUITable from '../../../common/MUITable';

export interface SCIQualifiedContact {
  civilite?: string;
  nom?: string;
  prenom?: string;
  telephone?: string;
  email?: string;
  adresse?: string;
}

interface SCIQualifiedContactsTableProps {
  contacts?: SCIQualifiedContact[];
  variant?: 'slim' | 'large';
  className?: string;
  emptyText?: string;
  showActions?: boolean;
  onDeleteContact?: (contact: SCIQualifiedContact, index: number) => void;
}

const SCIQualifiedContactsTable: React.FC<SCIQualifiedContactsTableProps> = ({
  contacts,
  variant = 'large',
  className,
  emptyText = 'Aucun contact qualifié',
  showActions = false,
  onDeleteContact,
}) => {
  const list = (contacts || []).filter((c) => !!c && (Object.values(c).some((v) => (typeof v === 'string' ? v.trim() !== '' : !!v))));

  if (list.length === 0) {
    return (
      <div className={`text-sm text-gray-500 ${className || ''}`.trim()}>
        {emptyText}
      </div>
    );
  }

  if (variant === 'slim') {
    const data = list.map((c, idx) => ({
      'Nom complet': [c.civilite, c.prenom, c.nom].filter(Boolean).join(' ').replaceAll(/\s+/g, ' ').trim() || '-',
      'Téléphone': c.telephone || '-',
      'Email': c.email || '-',
      ...(showActions ? {
        Actions: (
          <button
            className="rounded border border-red-600 px-2 py-0.5 text-xs text-red-600 hover:bg-red-600 hover:text-white"
            onClick={() => onDeleteContact && onDeleteContact(c, idx)}
          >
            Supprimer
          </button>
        ),
      } : {}),
    }));
    const headers = [
      { title: 'Nom complet' },
      { title: 'Téléphone' },
      { title: 'Email' },
      ...(showActions ? [{ title: 'Actions' }] : []),
    ];
    return (
      <MUITable
        data={data}
        headers={headers}
        tableClass={`min-w-full bg-white border text-xs ${className || ''}`.trim()}
        isSearchable={false}
        disablePagination
      />
    );
  }

  const data = list.map((c, idx) => ({
    Civilité: c.civilite || '-',
    Nom: c.nom || '-',
    Prénom: c.prenom || '-',
    Téléphone: c.telephone || '-',
    Email: c.email || '-',
    Adresse: c.adresse || '-',
    ...(showActions ? {
      Actions: (
        <button
          className="rounded border border-red-600 px-2 py-0.5 text-xs text-red-600 hover:bg-red-600 hover:text-white"
          onClick={() => onDeleteContact && onDeleteContact(c, idx)}
        >
          Supprimer
        </button>
      ),
    } : {}),
  }));
  const headers = [
    { title: 'Civilité' },
    { title: 'Nom' },
    { title: 'Prénom' },
    { title: 'Téléphone' },
    { title: 'Email' },
    { title: 'Adresse' },
    ...(showActions ? [{ title: 'Actions' }] : []),
  ];
  return (
    <MUITable
      data={data}
      headers={headers}
      tableClass={`min-w-full bg-white border text-sm ${className || ''}`.trim()}
      isSearchable={false}
      disablePagination
    />
  );
};

export default SCIQualifiedContactsTable;


